const MadeWithLove = () => {
    return (
        <div className="flex items-center justify-center text-xs d-hdpi-2:text-vw-xs mt-8 d-hdpi-2:mt-vw-8 gap-2 d-hdpi-2:gap-1">
            Made with
            <i className="text-xl d-hdpi-2:text-vw-xl ri-heart-line text-green-400" />
        </div>
    );
};

export default MadeWithLove;
